module.exports = __webpack_public_path__ + "img/clipboard.553e6a1a.svg";